import { useQuery } from '@apollo/client';
import { Headline1, Spinner } from 'aimo-ui';
import AccountContext from 'context/AccountContext';
import { READ_HSL_TICKET_RENDER } from 'graphql/queries/readHslTicketRender';
import useDeviceTimeAuthentication from 'hooks/useDeviceTimeAuthentication';
import { getLanguage } from 'i18n/init';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getUniqueIdSync } from 'react-native-device-info';
import WebView from 'react-native-webview';
import { useHslStore } from 'stores/hslStore';
import styled from 'styled-components/native';
import { StyledWrapper } from 'styles/ContainerStyles';
import {
  Lang,
  Query,
  QueryReadHslTicketRenderArgs,
} from 'types/generatedSchemaTypes';
import { isWeb } from 'utils/deviceUtils';
import { useUiStore } from 'stores/uiStore';

const RenderWrapper = styled.View`
  ${isWeb ? 'height: 75vh' : undefined};
`;

const Container = styled.View`
  height: 100%;
`;
const HslTicketRenderModalContent: React.FC = () => {
  const hslTicket = useHslStore((state) => state.selectedHslTicket);
  const { t } = useTranslation();
  const {
    customer: { contactEmail },
  } = useContext(AccountContext);

  const currentDeviceLanguage = (getLanguage() as Lang).toUpperCase();

  const { data: authenticateData, loading: authenticateLoading } =
    useDeviceTimeAuthentication();

  const { data, loading } = useQuery<Query, QueryReadHslTicketRenderArgs>(
    READ_HSL_TICKET_RENDER,
    {
      variables: {
        input: {
          ticketId: hslTicket?.ticketId || '',
          deviceId: isWeb ? contactEmail : getUniqueIdSync(),
          locale: currentDeviceLanguage,
        },
      },
      skip: !hslTicket?.ticketId,
    }
  );
  const ticketRender = data?.readHslTicketRender?.ticket;

  useEffect(() => {
    if (
      !authenticateLoading &&
      typeof authenticateData?.authenticateDeviceTime?.valid === 'boolean' &&
      !authenticateData?.authenticateDeviceTime?.valid
    ) {
      useUiStore.getState().setSheetModal('invalidDeviceTime');
    }
  }, [authenticateData, authenticateLoading]);

  const pageLoader =
    authenticateLoading ||
    loading ||
    !authenticateData?.authenticateDeviceTime?.valid;

  return (
    <Container testID="hsl-ticket-renderer-container">
      <RenderWrapper>
        {pageLoader && (
          <StyledWrapper center>
            <Spinner />
          </StyledWrapper>
        )}
        {!ticketRender && !pageLoader && (
          <StyledWrapper maxWidth={350} center mb={20}>
            <Headline1 center testID="hsl-unavailable">
              {t('hslTicket.unavailable')}
            </Headline1>
          </StyledWrapper>
        )}
        {ticketRender && (
          <Container>
            <WebView
              testID={'hsl-ticket-render'}
              source={{ html: ticketRender }}
            />
          </Container>
        )}
      </RenderWrapper>
    </Container>
  );
};

export default HslTicketRenderModalContent;
